import React from 'react';
import PublicSidebar from './PublicSidebar';
import useIsPublicDocumentationView from './useIsPublicDocumentationView';
import PageLayout from '../app/layout/PageLayout';
import useRouteHandle from '../app/useRouteHandle';

const PublicApp = () => {
  const { routeName } = useRouteHandle();
  const isPublicDocumentationView = useIsPublicDocumentationView();

  return (
    <PageLayout.Root
      elements={{
        sidebar: isPublicDocumentationView ? <PublicSidebar /> : undefined,
      }}
      routeName={routeName}
    />
  );
};

export default PublicApp;
